export default "__VITE_ASSET__CtrCEd6F__"